module.exports = __webpack_public_path__ + "static/img/logo-registro.9d98778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-registro.svg
// module id = 17A9
// module chunks = 126